import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

interface RelationContactState {
  relationContact: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: RelationContactState = {
  relationContact: null,
  loading: false,
  error: null,
};

export const fetchRelationContact = createAsyncThunk(
  "relation-contact/fetchRelationContact", 
  async (uid: string, { rejectWithValue }) => {
  try {
    const { response } = await Ows.handleRequest("Otys.Services.RelationContactService.getDetail", [
      uid,
      {
        uid: true,
        relationId: true,
        Person: {
          firstName: true,
          infix: true,
          lastName: true,
          emailPrimary: true,
          statusName: true,
          PhoneNumbers: {
            phoneNumber: true,
            type: true,
          },
          AddressPrimary: {
            address: true,
            postcode: true,
            city: true,
          },
        },
        profileImage: true,
      },
    ]);
    if (response) {
      return response;
    } else {
      return rejectWithValue("No relation contact found with this email.");
    }
  } catch (error: any) {
    return rejectWithValue("Failed to fetch relation contact.");
  }
});

const relationContactSlice = createSlice({
  name: "relationContact",
  initialState,
  reducers: {
    resetRelationContact: (state) => {
      state.relationContact = null;
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelationContact.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRelationContact.fulfilled, (state, action) => {
        state.relationContact = action.payload;
        state.loading = false;
      })
      .addCase(fetchRelationContact.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { resetRelationContact, clearError } = relationContactSlice.actions;
export default relationContactSlice.reducer;
